import useMartyContext from 'hooks/useMartyContext';
import { openPopup } from 'helpers';

import css from 'styles/containers/returns/returnLabelButtonsGroup.scss';

const buttonText = (isLabelless, singleBox, box) =>
  isLabelless ? (singleBox ? 'Show QR Code' : `Show QR Code for Box ${box}`) : singleBox ? 'Print Return Label' : `Print Label for Box ${box}`;

const ReturnLabelButtonsGroup = ({ postReturnInfo = [], boxInfo = {}, isLabelless = false }) => {
  const { marketplace } = useMartyContext();
  const {
    account: { returnLabelUrl }
  } = marketplace;
  const returnLabels = [];

  const singleBox = Object.keys(boxInfo).length === 1;
  for (const box in boxInfo) {
    // pull the asin from the first item in the box
    const asinInBox = boxInfo[box].items[0].asin;
    // get an item that matches asin in the return items
    // TODO: have backend change the unitId to handle same item in two different boxes since that field is now a miq link
    const matchingItem = postReturnInfo.find(({ returnItems }) => returnItems.find(({ asin }) => asin === asinInBox));
    // we can then associate the postReturnInfo item's contractId/rmaId with that specific box and display box-associated returnLabel
    if (matchingItem) {
      const { rmaId, contractId } = matchingItem;
      const printLabelButton = (
        <a
          href={`${returnLabelUrl}?contractId=${contractId}&displayInfo=true`}
          className={css.action}
          data-popup-options="width=1000,height=800"
          onClick={openPopup}
        >
          {buttonText(isLabelless, singleBox, box)}
        </a>
      );

      returnLabels.push(<span key={rmaId}>{printLabelButton}</span>);
    }
  }

  return <div className={css.container}>{returnLabels}</div>;
};

export default ReturnLabelButtonsGroup;
